enum PaymentStrategyType {
    ADYENV2 = 'adyenv2',
    ADYENV2_GOOGLEPAY = 'googlepayadyenv2',
    ADYENV3 = 'adyenv3',
    ADYENV3_GOOGLEPAY = 'googlepayadyenv3',
    AFFIRM = 'affirm',
    AFTERPAY = 'afterpay',
    AUTHORIZENET_GOOGLE_PAY = 'googlepayauthorizenet',
    AMAZONPAY = 'amazonpay',
    APPLEPAY = 'applepay',
    BLUESNAPV2 = 'bluesnapv2',
    BOLT = 'bolt',
    CBA_MPGS = 'cba_mpgs',
    CHECKOUTCOM = 'checkoutcom',
    CHECKOUTCOM_APM = 'checkoutcomapm',
    CHECKOUTCOM_FAWRY = 'checkoutcomfawry',
    CHECKOUTCOM_SEPA = 'checkoutcomsepa',
    CHECKOUTCOM_IDEAL = 'checkoutcomideal',
    CREDIT_CARD = 'creditcard',
    CHECKOUTCOM_GOOGLE_PAY = 'googlepaycheckoutcom',
    CLEARPAY = 'clearpay',
    CONVERGE = 'converge',
    CYBERSOURCE = 'cybersource',
    CYBERSOURCEV2 = 'cybersourcev2',
    BNZ = 'bnz',
    BNZ_GOOGLEPAY = 'googlepaybnz',
    CYBERSOURCEV2_GOOGLE_PAY = 'googlepaycybersourcev2',
    HUMM = 'humm',
    KLARNA = 'klarna',
    KLARNAV2 = 'klarnav2',
    LAYBUY = 'laybuy',
    LEGACY = 'legacy',
    MOLLIE = 'mollie',
    MONERIS = 'moneris',
    NO_PAYMENT_DATA_REQUIRED = 'nopaymentdatarequired',
    OFFLINE = 'offline',
    OFFSITE = 'offsite',
    ORBITAL_GOOGLE_PAY = 'googlepayorbital',
    PAYPAL_EXPRESS = 'paypalexpress',
    PAYPAL_EXPRESS_CREDIT = 'paypalexpresscredit',
    PAYPAL_COMMERCE = 'paypalcommerce',
    PAYPAL_COMMERCE_CREDIT = 'paypalcommercecredit',
    PAYPAL_COMMERCE_CREDIT_CARD = 'paypalcommercecreditcards',
    PAYPAL_COMMERCE_ALTERNATIVE_METHODS = 'paypalcommercealternativemethods',
    PAYPAL_COMMERCE_VENMO = 'paypalcommercevenmo',
    PPSDK = 'PAYMENT_TYPE_SDK',
    QUADPAY = 'quadpay',
    SAGE_PAY = 'sagepay',
    SQUARE = 'squarev2',
    STRIPEV3 = 'stripev3',
    STRIPE_UPE = 'stripeupe',
    STRIPE_UPE_GOOGLE_PAY = 'googlepaystripeupe',
    BRAINTREE = 'braintree',
    BRAINTREE_PAYPAL = 'braintreepaypal',
    BRAINTREE_VENMO = 'braintreevenmo',
    BRAINTREE_PAYPAL_CREDIT = 'braintreepaypalcredit',
    BRAINTREE_VISA_CHECKOUT = 'braintreevisacheckout',
    BRAINTREE_GOOGLE_PAY = 'googlepaybraintree',
    WE_PAY = 'wepay',
    WORLDPAYACCESS = 'worldpayaccess',
    WORLDPAYACCESS_GOOGLE_PAY = 'googlepayworldpayaccess',
    STRIPE_GOOGLE_PAY = 'googlepaystripe',
    SEZZLE = 'sezzle',
    ZIP = 'zip',
}

export default PaymentStrategyType;
